import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
import Popover from "components/common/Popover";
const StyledButton = styled(Button)`
  padding: 1px 0;
`;
const StyledOverlay = styled(Popover.Dropdown)`
  white-space: pre-line;
`;
const StyledIcon = styled(Icon)(
  ({ $bsStyle, theme }) => css`
    color: ${theme.colors.variant[$bsStyle]};
  `
);
const HelpPopoverButton = ({ helpText, bsStyle = "info", bsSize = "medium" }) => {
  const [showHelp, setShowHelp] = useState(false);
  const toggleHelp = () => setShowHelp((cur) => !cur);
  return /* @__PURE__ */ React.createElement(
    Popover,
    {
      position: "right",
      width: 500,
      opened: showHelp,
      withArrow: true,
      onChange: setShowHelp,
      closeOnClickOutside: true,
      withinPortal: true
    },
    /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "transparent", bsSize, onClick: toggleHelp }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "help", $bsStyle: bsStyle }))),
    /* @__PURE__ */ React.createElement(StyledOverlay, null, helpText)
  );
};
export default HelpPopoverButton;
